import api from "../../api/sphinxAPI";

/** =========== VISUALIZER =========== **/

export const getUser = async function(userID) {
  if (!userID) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/user`,
      params: { userID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getAllUsers = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/allusers`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getAllUsersCount = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/userscount`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getUpcomingSession = async function(sessionID) {
  if (!sessionID) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/session`,
      params: { sessionID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getUpcomingSessionsFor8Days = async function() {
  let response = null;
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/sessionsFor8Days`,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const getUserPastSessions = async function(userID, limit, rangeStart, otherUserID) {
  if (!userID || !limit) {
    throw new Error("Required data not provided for request.");
  }

  let requestObject = { userID, limit };
  if (rangeStart) {
    requestObject.rangeStart = rangeStart;
  }

  if (otherUserID) {
    requestObject.otherUserID = otherUserID;
  }

  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/userPastSessions`,
      data: requestObject,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const manuallyVerify = async function(userID) {
  if (!userID) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/manuallyVerify`,
      params: { userID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const toggleRematchValue = async function(sessionData) {
  if (!sessionData.userID || !sessionData.sessionID || (!sessionData.newValue && sessionData.newValue !== false)) {
    console.log("sessionData @request: ", sessionData);
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/toggleRematchValue`,
      data: sessionData,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const rectifySession = async function(sessionID) {
  if (!sessionID) {
    console.log("sessionID @request: ", sessionID);
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/rectifySession`,
      data: { sessionID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

export const rectifyAccount = async function(UID) {
  if (!UID) {
    console.log("UID @request: ", UID);
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/rectifyAccount`,
      data: { UID },
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
  } catch (error) {
    console.log(error);
  }
  return response;
};

/** =========== SESSION EXPLORER =========== **/

export const getSessionsForIDs = async function(UID_1, UID_2) {
  if (!UID_1 || !UID_2) {
    throw new Error("Required data not provided for request.");
  }
  let response = null;
  const data = {
    UID_1,
    UID_2,
  };
  try {
    response = await api.REQUEST({
      method: "get",
      url: `api/sphinx/sessionsForIDs`,
      data: data,
      withCredentials: true,
    });

    if (!response) {
      throw new Error("Request failed.");
    }
    if (response && response.data && response.data.sessions) {
      const sessions = response.data.sessions;
      return sessions;
    }
  } catch (error) {
    console.log(error);
  }
};

/** =========== BADGE CONTROLLER =========== **/

export const awardNewBadge = async function(data) {
  if (!data.userID || (!data.badgeNr && data.badgeNr !== 0)) {
    console.log("data @request: ", data);
    return { error: "Required data not provided for request." };
  }
  let response = null;
  try {
    response = await api.REQUEST({
      method: "post",
      url: `api/sphinx/awardNewBadge`,
      data: data,
      withCredentials: true,
    });

    console.log("RESPON", response);
    if (!response) {
      return { error: "Request failed." };
    }
  } catch (error) {
    console.log(error);
    return { error: "Request failed." };
  }
  return response.data;
};

const InternalRequests = {
  getUser,
  getAllUsers,
  getAllUsersCount,
  getUpcomingSession,
  getUpcomingSessionsFor8Days,
  getUserPastSessions,
  manuallyVerify,
  toggleRematchValue,
  getSessionsForIDs,
  awardNewBadge,
  rectifySession,
  rectifyAccount,
};

export default InternalRequests;
